import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-field p-mt-3" }
const _hoisted_3 = { for: "category" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { for: "reference" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { for: "name" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Conversion du produit", -1)
const _hoisted_11 = { class: "p-d-flex p-ai-center" }
const _hoisted_12 = { class: "p-ml-2" }
const _hoisted_13 = {
  key: 0,
  class: "p-field"
}
const _hoisted_14 = { for: "threshold" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = { for: "purchaseCost" }
const _hoisted_17 = { class: "p-d-flex p-my-4" }
const _hoisted_18 = { class: "p-ml-3" }

import { ref } from "vue";
import { useUpdateProduct } from "@/graphql/product/update.product";
import { activeActivity } from "@/plugins/i18n";
import { Category, Product } from "@/graphql/types";
import { numberSeparators } from "@/graphql/utils/utils";
import { useI18n } from "vue-i18n";
import PriceInput from "@/components/product/PriceInput.vue";
import ImageCropper from "@/components/common/ImageCropper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateProduct',
  props: {
    item: {},
    src: {},
    categories: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const { t, tm } = useI18n();
const title = ref("");

function onShow() {
  const pro: Product = props.item;
  if (pro) {
    form.id = pro.id;
    form.categoryId = pro.category.id;
    form.reference.$value = pro.reference;
    form.name.$value = pro.name;
    form.type.$value = pro.type;
    form.changeable.$value = pro.changeable;
    form.threshold.$value = pro.threshold;
    title.value = `${t("update.title")}`;
    if (pro.notStorable) {
      Object.keys(pro.notStorable).forEach((key) => {
        if (form.notStorableInput[key])
          form.notStorableInput[key]["$value"] = pro.notStorable[key];
      });
      title.value += `[${tm("product.types")[pro.type].toLowerCase()}]`;
    } else title.value += `[${tm("product.types")[pro.type].toLowerCase()}]`;
  }
}

const { loading, image, form, validateUpdate, cropperRef, canUpdate } =
  useUpdateProduct(() => emit("update:modelValue", false));

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: title.value,
    visible: _ctx.modelValue,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    breakpoints: { '960px': '96vw' },
    style: { width: '450px' },
    onShow: onShow
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('validate'),
        icon: "pi pi-send",
        class: "p-button-outlined",
        disabled: !_unref(canUpdate),
        onClick: _cache[14] || (_cache[14] = ($event: any) => ((_ctx.$refs['submitter'] as any).$el.click())),
        loading: _unref(loading)
      }, null, 8, ["label", "disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        autocomplete: "off",
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_unref(validateUpdate)()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("product.category")), 1),
            _createVNode(_component_Dropdown, {
              modelValue: _unref(form).categoryId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).categoryId) = $event)),
              options: _ctx.categories,
              filter: true,
              optionLabel: "label",
              "filter-fields": ['label'],
              "scroll-height": "150px",
              "empty-filter-message": _ctx.$t('noResult'),
              id: "category",
              "data-key": "id",
              "option-value": "id"
            }, null, 8, ["modelValue", "options", "empty-filter-message"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("product.reference")) + " ", 1),
              _hoisted_6
            ]),
            _createVNode(_component_InputText, {
              modelValue: _unref(form).reference.$value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).reference.$value) = $event)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref(form).reference.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).reference.$hasError }),
              id: "reference"
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("product.name")) + " ", 1),
              _hoisted_9
            ]),
            _createVNode(_component_InputText, {
              modelValue: _unref(form).name.$value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).name.$value) = $event)),
              id: "name",
              type: "text",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(form).name.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
            }, null, 8, ["modelValue", "class"])
          ]),
          _hoisted_10,
          _createVNode(_component_Divider, {
            class: "p-mt-2",
            layout: "horizontal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _unref(form).type.$value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).type.$value) = $event)),
                  "true-value": 0,
                  "false-value": 1
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$tm("product.storable")), 1)
              ])
            ]),
            _: 1
          }),
          (_unref(form).type.$value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("product.threshold")), 1),
                _createVNode(_component_InputNumber, {
                  modelValue: _unref(form).threshold.$value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).threshold.$value) = $event)),
                  locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                  "max-fraction-digits": 20,
                  min: 0,
                  "allow-empty": false,
                  mode: "decimal",
                  id: "threshold"
                }, null, 8, ["modelValue", "locale"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("product.purchaseCost")), 1),
                  _createVNode(_component_InputNumber, {
                    modelValue: _unref(form).notStorableInput.purchasePrice.$value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).notStorableInput.purchasePrice.$value) = $event)),
                    locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                    "max-fraction-digits": 20,
                    "allow-empty": false,
                    min: 0,
                    id: "purchaseCost",
                    mode: "decimal"
                  }, null, 8, ["modelValue", "locale"])
                ]),
                _createVNode(PriceInput, {
                  exclTax: _unref(form).notStorableInput.exclTax.$value,
                  "onUpdate:exclTax": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).notStorableInput.exclTax.$value) = $event)),
                  inclTax: _unref(form).notStorableInput.inclTax.$value,
                  "onUpdate:inclTax": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).notStorableInput.inclTax.$value) = $event)),
                  vat: _unref(form).notStorableInput.vat.$value,
                  "onUpdate:vat": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).notStorableInput.vat.$value) = $event))
                }, null, 8, ["exclTax", "inclTax", "vat"])
              ], 64)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(form).changeable.$value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).changeable.$value) = $event)),
              "true-value": 1,
              "false-value": 0
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("product.changeable")), 1)
          ])
        ]),
        _createVNode(ImageCropper, {
          ref_key: "cropperRef",
          ref: cropperRef,
          src: _ctx.src,
          modelValue: _unref(image),
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(image) ? (image).value = $event : null))
        }, null, 8, ["src", "modelValue"]),
        _withDirectives(_createVNode(_component_Button, {
          type: "submit",
          ref: "submitter"
        }, null, 512), [
          [_vShow, false]
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}
}

})